<template>
  <div style="text-align: center">
    <Main />
  </div>
</template>

<script>
import Main from "./index/Main";
export default {
  name: "User",
  components: {
    Main,
  },
};
</script>



// WEBPACK FOOTER //
// src/components/admin/Main.vue